import { Form, message } from 'antd'
import { useContext } from 'react'
import { useMutation } from 'react-query'
import Context from '../Context'
import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'
import find from 'lodash/find'
import authService from 'authService'
import useLogAction from 'hooks/useLogAction'

const authApp = process.env.REACT_APP_AUTH_URL

const updateUser = async ({
  id,
  username,
  firstname,
  lastname,
  password = "123456",
  roles,
  isNew
}) => {
  const path = !isNew ? 'add' : 'edit'
  const data = await axiosRequest({
    url: `/user/${path}`,
    baseURL: authApp,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    },
    data: {
      id,
      username,
      firstname,
      lastname,
      role: roles,
      password
    }
  })

  if (get(data, 'response.data.errorCode')) throw new Error('Request Error')

  return data.data
}

const useUpdateUser = () => {
  const [form] = Form.useForm()
  const { logAction } = useLogAction()
  const {
    states: { selectedUser, type },
    actions: { onClose, setSelectedUser, setDirtyBit },
    queryHandler: { data: dataU }
  } = useContext(Context)

  const { isLoading, mutate } = useMutation({
    mutationKey: 'update_auth_user',
    mutationFn: updateUser,
    onSuccess: () => {
      const user = form.getFieldsValue(true)
      const lastUser =
        find(dataU, ({ id }) => selectedUser === id) ?? {}

      onClose()
      logAction({
        event: "USER", action: "UPDATE", metadata: {
          actionType: type === 'updateUser' ? "editOperatorInfo" : "addOperatorInfo",
          ...(type === 'updateUser' ? {
            lastUserInfo: {
              uuid: selectedUser,
              firstname: lastUser.firstname,
              lastname: lastUser.lastname,
              email: lastUser.username,
              roles: lastUser.roles
            }
          } : {}),
          userInfo: {
            uuid: selectedUser,
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.username,
            roles: user.roles
          }
        }
      })
      setSelectedUser('')
      setDirtyBit(true)
      if (form.getFieldValue("username") === authService.state.username) window.location.reload()

      form.resetFields()
      message.success({
        type: 'success',
        content: 'El usuario fue actualizado correctamente'
      })
    },
    onError: () => {
      message.error({
        type: 'error',
        content: 'Ha ocurrido un error'
      })
    }
  })

  const onClick = () => {
    form
      .validateFields()
      .then(() => {
        mutate({ ...form.getFieldsValue(true), uuid: selectedUser, isNew: type === 'updateUser' })
      })
      .catch(() => { })
  }

  return {
    onClick,
    form,
    isLoading
  }
}

export default useUpdateUser
